import { getToken } from '../api.js';

/**
 * GET for the admin views, with the vanilla admin modules' error wording.
 *
 * They did not go through the shared api(): each fetched directly and, on a
 * failed response, showed the server's `error` or its OWN fallback sentence
 * ("Could not load companies.", "Could not load the DII report."). api()
 * would say "Request failed" instead, so the fallback is passed per call.
 */
export async function adminFetch(path, fallback) {
  const response = await fetch(path, { headers: { Authorization: `Bearer ${getToken()}` } });
  if (!response.ok) {
    const { error } = await response.json().catch(() => ({}));
    throw new Error(error ?? fallback);
  }
  return response.json();
}
